import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import AuthSlice from './Reducer/AuthReducer/AuthSlice';
import SnackBarSlice from './Reducer/SnackBarReducer/SnackBarSlice';
import ScreenSlice from './Reducer/ScreenReducer/ScreenSlice';
import DrawerMainLayoutSlice from './Reducer/DrawerMainLayoutReducer/DrawerMainLayoutSlice';
import TableSlice from './Reducer/TableReducer/TableSlice';

const rootReducer = {
  AuthReducer: AuthSlice,
  ScreenReducer: ScreenSlice,
  SnackBarReducer: SnackBarSlice,
  DrawerMainLayoutReducer: DrawerMainLayoutSlice,
  TableReducer: TableSlice
};

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['SnackBarReducer', 'ScreenReducer', 'TableReducer'],
  whitelist: ['AuthReducer', 'DrawerMainLayoutReducer'],
};

const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer));

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionPaths: ['register', 'rehydrate'],
        ignoredPaths: ['SnackBarReducer.register'],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
